export const githubLink = "https://github.com/Joseph-Skinner"
export const linkedInLink = "https://www.linkedin.com/in/josephwskinner/"
